import { computeDefaultTemplateLabel, computeDefaultTemplatesLabel } from './actions';
import { defaultTemplateResource as resource } from './resource';
export const defaultTemplateSelector = (state, {
  productType,
  process,
  sharingId
}) => {
  const label = computeDefaultTemplateLabel(productType, process, sharingId);
  return state.template2.defaults[label];
};
export const selectIsFetchingOneDefaultTemplate = (state, {
  productType,
  process,
  sharingId
}) => resource.selectIsFetchingOne(state, computeDefaultTemplateLabel(productType, process, sharingId));
export const selectIsLoadedOneDefaultTemplate = (state, {
  productType,
  process,
  sharingId
}) => resource.selectIsLoadedOne(state, computeDefaultTemplateLabel(productType, process, sharingId));
export const selectIsFailureOneDefaultTemplate = (state, {
  productType,
  process,
  sharingId
}) => resource.selectIsFailureOne(state, computeDefaultTemplateLabel(productType, process, sharingId));
export const selectIsToRefetchOneDefaultTemplate = (state, {
  productType,
  process,
  sharingId
}) => resource.selectIsToRefetchOne(state, computeDefaultTemplateLabel(productType, process, sharingId));
export const selectIsDeletingOneDefaultTemplate = (state, {
  productType,
  process,
  sharingId
}) => resource.selectIsDeletingOne(state, computeDefaultTemplateLabel(productType, process, sharingId));
export const selectShouldFetchOneDefaultTemplate = (state, {
  productType,
  process,
  sharingId
}) => resource.selectShouldFetchOne(state, computeDefaultTemplateLabel(productType, process, sharingId));
export const selectIsFetchingDefaultTemplates = (state, {
  sharingId
}) => resource.selectIsFetching(state, computeDefaultTemplatesLabel(sharingId));
export const selectIsLoadedDefaultTemplates = (state, {
  sharingId
}) => resource.selectIsLoaded(state, computeDefaultTemplatesLabel(sharingId));
export const selectIsFailureDefaultTemplates = (state, {
  sharingId
}) => resource.selectIsFailure(state, computeDefaultTemplatesLabel(sharingId));
export const selectIsToRefetchDefaultTemplates = (state, {
  sharingId
}) => resource.selectIsToRefetch(state, computeDefaultTemplatesLabel(sharingId));
export const selectShouldFetchDefaultTemplates = (state, {
  sharingId
}) => resource.selectShouldFetch(state, computeDefaultTemplatesLabel(sharingId));